// ink-component
import React from 'react';
import styled from 'styled-components';

const NewFormSectionContentElement = styled.div``;

/**
 * @purpose Arranges the Fields with the proper spacing inside sections
 * @categories form
 * @group NewFormSection
 * @position 5
 * @HTMLType HTMLDivElement
 */
// eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
function NewFormSectionContent(props: React.HTMLAttributes<HTMLDivElement>) {
  const { children, style, className, ...otherProps } = props;
  return <NewFormSectionContentElement {...otherProps}>{children}</NewFormSectionContentElement>;
}

NewFormSectionContent.displayName = 'NewFormSection.Content';

export default NewFormSectionContent;
